export default function loadLocale(locale) {
  return new Promise((resolve) => {
    switch (locale) {
    case 'en':
  
      case 'en-US': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./en-US', (require) => {
          const data = require('./en-US');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'en-US');
      } else {
          const data = require('./en-US');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
      default:
        return resolve(null);
    }
  });
}
